<template>
  <el-select
    class="width-200"
    v-model="customerId"
    placeholder="所有客户"
    clearable
    filterable
    @change="changeFn"
  >
    <el-option
      v-for="item in customerOptions"
      :key="item.id"
      :label="item.company_name"
      :value="item.id"
    > </el-option>
  </el-select>
</template>

<script>
import { GetCustomerList } from '@/api/customer';

export default {
  name: 'FilterCustomer',
  props: {
    value: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      customerId: '',
      customerOptions: []
    };
  },
  created() {
    this.getCustomerList();
  },
  methods: {
    changeFn() {
      this.$emit('change', {
        type: 'customer',
        value: this.customerId
      });
    },
    getCustomerList() {
      GetCustomerList().then(res => {
        this.customerOptions = res.data.list || [];
        this.customerId = this.value;
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
